import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import success_image from "../images/Illustration-success.png";
import { BASE } from "../basedata/constants";
import { apiUser } from "../basedata/apiCall";

import rgIcon from './../images/document_type.svg'
import cnhIcon from './../images/document_type_cnh.svg'
import { Box } from "@mui/material";


const DocumentReuse = () => {
  const { t } = useTranslation(); 

  const chooseDocument = async () => {
    const _current_token = sessionStorage.getItem('token')
    try{
      const _response = await apiUser.post(`/biometry/document/reuse`, {flowId: _current_token})
      if(_response.data?.status === 'success'){
        return window.location.href = '/success'
      }
      return window.location.href = '/mobile-document'
    }catch(e){
      console.log(e)
    }
  }


  return (
    <div className="success-container">
      <div className="progress-indicator">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="progress-bar"></div>
        ))}
      </div>
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="success_title">
            Sucesso!
          </h1>
          <div className="success-message-container">
            <p className="success-message">
            <strong>
            Encontramos um dos seus documentos de identificação.  
            </strong> <br/><br/>
            Deseja utilizar esse documento para finalizar seu cadastro?
            </p>


           <button onClick={() => chooseDocument()} className="continue-button"
    >
      Sim, finalizar cadastro
    </button>

    <button onClick={() => {window.location.href = '/mobile-document'}} className="continue-button btn-ghost"
    >
      Não, re-enviar documentos
    </button>


            <p className="document-reuse-disclaimer">
            Ao responder sim, seu documento de identificação armazenado em nossa base ou de terceiros será reutilizado, entenda sobre a <a 
          href="/bepass_terms.pdf" rel="noreferrer noopener" target="_blank"
          className="bold-link"
        >privacidade dos seus dados</a>.
            </p>

          </div>
        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default DocumentReuse;